import React from 'react'

const React_Course_Exam = () => {
  return (
    <div>
      <h1>React Exam</h1>
    </div>
  )
}

export default React_Course_Exam
